//
// WARNING: this file was auto-generated by @phensley/cldr-compiler. DO NOT EDIT.
//
export var cardinalRules = {
    af: [[1, [[0]]]],
    ak: [[1, [[1]]]],
    am: [[1, [[2], [0]]]],
    an: [[1, [[0]]]],
    ar: [
        [0, [[3]]],
        [1, [[0]]],
        [2, [[4]]],
        [3, [[5]]],
        [4, [[6]]]
    ],
    ars: [
        [0, [[3]]],
        [1, [[0]]],
        [2, [[4]]],
        [3, [[5]]],
        [4, [[6]]]
    ],
    as: [[1, [[2], [0]]]],
    asa: [[1, [[0]]]],
    ast: [[1, [[7, 8]]]],
    az: [[1, [[0]]]],
    be: [
        [1, [[9, 10]]],
        [3, [[11, 12]]],
        [4, [[13], [14], [15]]]
    ],
    bem: [[1, [[0]]]],
    bez: [[1, [[0]]]],
    bg: [[1, [[0]]]],
    bho: [[1, [[1]]]],
    bm: [],
    bn: [[1, [[2], [0]]]],
    bo: [],
    br: [
        [1, [[9, 16]]],
        [2, [[17, 18]]],
        [3, [[19, 20]]],
        [4, [[21, 22]]]
    ],
    brx: [[1, [[0]]]],
    bs: [
        [
            1,
            [
                [8, 23, 24],
                [25, 26]
            ]
        ],
        [
            3,
            [
                [8, 27, 28],
                [29, 30]
            ]
        ]
    ],
    ca: [[1, [[7, 8]]]],
    ce: [[1, [[0]]]],
    ceb: [
        [
            1,
            [
                [8, 31],
                [8, 32],
                [33, 34]
            ]
        ]
    ],
    cgg: [[1, [[0]]]],
    chr: [[1, [[0]]]],
    ckb: [[1, [[0]]]],
    cs: [
        [1, [[7, 8]]],
        [3, [[35, 8]]],
        [4, [[33]]]
    ],
    cy: [
        [0, [[3]]],
        [1, [[0]]],
        [2, [[4]]],
        [3, [[36]]],
        [4, [[37]]]
    ],
    da: [[1, [[0], [38, 39]]]],
    de: [[1, [[7, 8]]]],
    dsb: [
        [1, [[8, 40], [41]]],
        [2, [[8, 42], [43]]],
        [3, [[8, 44], [45]]]
    ],
    dv: [[1, [[0]]]],
    dz: [],
    ee: [[1, [[0]]]],
    el: [[1, [[0]]]],
    en: [[1, [[7, 8]]]],
    eo: [[1, [[0]]]],
    es: [[1, [[0]]]],
    et: [[1, [[7, 8]]]],
    eu: [[1, [[0]]]],
    fa: [[1, [[2], [0]]]],
    ff: [[1, [[39]]]],
    fi: [[1, [[7, 8]]]],
    fil: [
        [
            1,
            [
                [8, 31],
                [8, 32],
                [33, 34]
            ]
        ]
    ],
    fo: [[1, [[0]]]],
    fr: [[1, [[39]]]],
    fur: [[1, [[0]]]],
    fy: [[1, [[7, 8]]]],
    ga: [
        [1, [[0]]],
        [2, [[4]]],
        [3, [[46]]],
        [4, [[47]]]
    ],
    gd: [
        [1, [[48]]],
        [2, [[49]]],
        [3, [[50]]]
    ],
    gl: [[1, [[7, 8]]]],
    gsw: [[1, [[0]]]],
    gu: [[1, [[2], [0]]]],
    guw: [[1, [[1]]]],
    gv: [
        [1, [[8, 23]]],
        [2, [[8, 51]]],
        [3, [[8, 52]]],
        [4, [[33]]]
    ],
    ha: [[1, [[0]]]],
    haw: [[1, [[0]]]],
    he: [
        [1, [[7, 8]]],
        [2, [[53, 8]]],
        [4, [[8, 54, 13]]]
    ],
    hi: [[1, [[2], [0]]]],
    hr: [
        [
            1,
            [
                [8, 23, 24],
                [25, 26]
            ]
        ],
        [
            3,
            [
                [8, 27, 28],
                [29, 30]
            ]
        ]
    ],
    hsb: [
        [1, [[8, 40], [41]]],
        [2, [[8, 42], [43]]],
        [3, [[8, 44], [45]]]
    ],
    hu: [[1, [[0]]]],
    hy: [[1, [[39]]]],
    ia: [[1, [[7, 8]]]],
    id: [],
    ig: [],
    ii: [],
    in: [],
    io: [[1, [[7, 8]]]],
    is: [[1, [[55, 23, 24], [38]]]],
    it: [[1, [[7, 8]]]],
    iu: [
        [1, [[0]]],
        [2, [[4]]]
    ],
    iw: [
        [1, [[7, 8]]],
        [2, [[53, 8]]],
        [4, [[8, 54, 13]]]
    ],
    ja: [],
    jbo: [],
    jgo: [[1, [[0]]]],
    ji: [[1, [[7, 8]]]],
    jmc: [[1, [[0]]]],
    jv: [],
    jw: [],
    ka: [[1, [[0]]]],
    kab: [[1, [[39]]]],
    kaj: [[1, [[0]]]],
    kcg: [[1, [[0]]]],
    kde: [],
    kea: [],
    kk: [[1, [[0]]]],
    kkj: [[1, [[0]]]],
    kl: [[1, [[0]]]],
    km: [],
    kn: [[1, [[2], [0]]]],
    ko: [],
    ks: [[1, [[0]]]],
    ksb: [[1, [[0]]]],
    ksh: [
        [0, [[3]]],
        [1, [[0]]]
    ],
    ku: [[1, [[0]]]],
    kw: [
        [0, [[3]]],
        [1, [[0]]],
        [2, [[56], [57, 58], [21, 59]]],
        [3, [[60]]],
        [4, [[61, 62]]]
    ],
    ky: [[1, [[0]]]],
    lag: [
        [0, [[3]]],
        [1, [[39, 21]]]
    ],
    lb: [[1, [[0]]]],
    lg: [[1, [[0]]]],
    lkt: [],
    ln: [[1, [[1]]]],
    lo: [],
    lt: [
        [1, [[9, 63]]],
        [3, [[64, 63]]],
        [4, [[65]]]
    ],
    lv: [
        [0, [[13], [66], [67, 68]]],
        [
            1,
            [
                [9, 10],
                [67, 25, 26],
                [69, 25]
            ]
        ]
    ],
    mas: [[1, [[0]]]],
    mg: [[1, [[1]]]],
    mgo: [[1, [[0]]]],
    mk: [
        [
            1,
            [
                [8, 23, 24],
                [25, 26]
            ]
        ]
    ],
    ml: [[1, [[0]]]],
    mn: [[1, [[0]]]],
    mo: [
        [1, [[7, 8]]],
        [3, [[33], [3], [70]]]
    ],
    mr: [[1, [[0]]]],
    ms: [],
    mt: [
        [1, [[0]]],
        [3, [[3], [71]]],
        [4, [[66]]]
    ],
    my: [],
    nah: [[1, [[0]]]],
    naq: [
        [1, [[0]]],
        [2, [[4]]]
    ],
    nb: [[1, [[0]]]],
    nd: [[1, [[0]]]],
    ne: [[1, [[0]]]],
    nl: [[1, [[7, 8]]]],
    nn: [[1, [[0]]]],
    nnh: [[1, [[0]]]],
    no: [[1, [[0]]]],
    nqo: [],
    nr: [[1, [[0]]]],
    nso: [[1, [[1]]]],
    ny: [[1, [[0]]]],
    nyn: [[1, [[0]]]],
    om: [[1, [[0]]]],
    or: [[1, [[0]]]],
    os: [[1, [[0]]]],
    osa: [],
    pa: [[1, [[1]]]],
    pap: [[1, [[0]]]],
    pcm: [[1, [[2], [0]]]],
    pl: [
        [1, [[7, 8]]],
        [3, [[8, 27, 28]]],
        [
            4,
            [
                [8, 72, 73],
                [8, 74],
                [8, 75]
            ]
        ]
    ],
    prg: [
        [0, [[13], [66], [67, 68]]],
        [
            1,
            [
                [9, 10],
                [67, 25, 26],
                [69, 25]
            ]
        ]
    ],
    ps: [[1, [[0]]]],
    pt: [[1, [[76]]]],
    'pt-PT': [[1, [[7, 8]]]],
    rm: [[1, [[0]]]],
    ro: [
        [1, [[7, 8]]],
        [3, [[33], [3], [70]]]
    ],
    rof: [[1, [[0]]]],
    root: [],
    ru: [
        [1, [[8, 23, 24]]],
        [3, [[8, 27, 28]]],
        [
            4,
            [
                [8, 77],
                [8, 74],
                [8, 78]
            ]
        ]
    ],
    rwk: [[1, [[0]]]],
    sah: [],
    saq: [[1, [[0]]]],
    sat: [
        [1, [[0]]],
        [2, [[4]]]
    ],
    sc: [[1, [[7, 8]]]],
    scn: [[1, [[7, 8]]]],
    sd: [[1, [[0]]]],
    sdh: [[1, [[0]]]],
    se: [
        [1, [[0]]],
        [2, [[4]]]
    ],
    seh: [[1, [[0]]]],
    ses: [],
    sg: [],
    sh: [
        [
            1,
            [
                [8, 23, 24],
                [25, 26]
            ]
        ],
        [
            3,
            [
                [8, 27, 28],
                [29, 30]
            ]
        ]
    ],
    shi: [
        [1, [[2], [0]]],
        [3, [[79]]]
    ],
    si: [[1, [[80], [2, 81]]]],
    sk: [
        [1, [[7, 8]]],
        [3, [[35, 8]]],
        [4, [[33]]]
    ],
    sl: [
        [1, [[8, 40]]],
        [2, [[8, 42]]],
        [3, [[8, 44], [33]]]
    ],
    sma: [
        [1, [[0]]],
        [2, [[4]]]
    ],
    smi: [
        [1, [[0]]],
        [2, [[4]]]
    ],
    smj: [
        [1, [[0]]],
        [2, [[4]]]
    ],
    smn: [
        [1, [[0]]],
        [2, [[4]]]
    ],
    sms: [
        [1, [[0]]],
        [2, [[4]]]
    ],
    sn: [[1, [[0]]]],
    so: [[1, [[0]]]],
    sq: [[1, [[0]]]],
    sr: [
        [
            1,
            [
                [8, 23, 24],
                [25, 26]
            ]
        ],
        [
            3,
            [
                [8, 27, 28],
                [29, 30]
            ]
        ]
    ],
    ss: [[1, [[0]]]],
    ssy: [[1, [[0]]]],
    st: [[1, [[0]]]],
    su: [],
    sv: [[1, [[7, 8]]]],
    sw: [[1, [[7, 8]]]],
    syr: [[1, [[0]]]],
    ta: [[1, [[0]]]],
    te: [[1, [[0]]]],
    teo: [[1, [[0]]]],
    th: [],
    ti: [[1, [[1]]]],
    tig: [[1, [[0]]]],
    tk: [[1, [[0]]]],
    tl: [
        [
            1,
            [
                [8, 31],
                [8, 32],
                [33, 34]
            ]
        ]
    ],
    tn: [[1, [[0]]]],
    to: [],
    tr: [[1, [[0]]]],
    ts: [[1, [[0]]]],
    tzm: [[1, [[1], [82]]]],
    ug: [[1, [[0]]]],
    uk: [
        [1, [[8, 23, 24]]],
        [3, [[8, 27, 28]]],
        [
            4,
            [
                [8, 77],
                [8, 74],
                [8, 78]
            ]
        ]
    ],
    ur: [[1, [[7, 8]]]],
    uz: [[1, [[0]]]],
    ve: [[1, [[0]]]],
    vi: [],
    vo: [[1, [[0]]]],
    vun: [[1, [[0]]]],
    wa: [[1, [[1]]]],
    wae: [[1, [[0]]]],
    wo: [],
    xh: [[1, [[0]]]],
    xog: [[1, [[0]]]],
    yi: [[1, [[7, 8]]]],
    yo: [],
    yue: [],
    zh: [],
    zu: [[1, [[2], [0]]]]
};
export var ordinalRules = {
    af: [],
    am: [],
    an: [],
    ar: [],
    as: [
        [1, [[83]]],
        [2, [[84]]],
        [3, [[85]]],
        [4, [[37]]]
    ],
    az: [
        [1, [[86], [87]]],
        [3, [[88], [89]]],
        [4, [[2], [90], [91]]]
    ],
    be: [[3, [[92, 93]]]],
    bg: [],
    bn: [
        [1, [[83]]],
        [2, [[84]]],
        [3, [[85]]],
        [4, [[37]]]
    ],
    bs: [],
    ca: [
        [1, [[94]]],
        [2, [[4]]],
        [3, [[85]]]
    ],
    ce: [],
    cs: [],
    cy: [
        [0, [[95]]],
        [1, [[0]]],
        [2, [[4]]],
        [3, [[96]]],
        [4, [[97]]]
    ],
    da: [],
    de: [],
    dsb: [],
    el: [],
    en: [
        [1, [[9, 10]]],
        [2, [[17, 98]]],
        [3, [[99, 100]]]
    ],
    es: [],
    et: [],
    eu: [],
    fa: [],
    fi: [],
    fil: [[1, [[0]]]],
    fr: [[1, [[0]]]],
    fy: [],
    ga: [[1, [[0]]]],
    gd: [
        [1, [[48]]],
        [2, [[49]]],
        [3, [[101]]]
    ],
    gl: [],
    gsw: [],
    gu: [
        [1, [[0]]],
        [2, [[84]]],
        [3, [[85]]],
        [4, [[37]]]
    ],
    he: [],
    hi: [
        [1, [[0]]],
        [2, [[84]]],
        [3, [[85]]],
        [4, [[37]]]
    ],
    hr: [],
    hsb: [],
    hu: [[1, [[102]]]],
    hy: [[1, [[0]]]],
    ia: [],
    id: [],
    in: [],
    is: [],
    it: [[4, [[103]]]],
    iw: [],
    ja: [],
    ka: [
        [1, [[7]]],
        [4, [[2], [104]]]
    ],
    kk: [[4, [[105], [106], [13, 21]]]],
    km: [],
    kn: [],
    ko: [],
    kw: [
        [1, [[107], [108]]],
        [4, [[109], [110]]]
    ],
    ky: [],
    lo: [[1, [[0]]]],
    lt: [],
    lv: [],
    mk: [
        [1, [[23, 24]]],
        [2, [[51, 111]]],
        [4, [[112, 113]]]
    ],
    ml: [],
    mn: [],
    mo: [[1, [[0]]]],
    mr: [
        [1, [[0]]],
        [2, [[84]]],
        [3, [[85]]]
    ],
    ms: [[1, [[0]]]],
    my: [],
    nb: [],
    ne: [[1, [[107]]]],
    nl: [],
    or: [
        [1, [[114]]],
        [2, [[84]]],
        [3, [[85]]],
        [4, [[37]]]
    ],
    pa: [],
    pl: [],
    prg: [],
    ps: [],
    pt: [],
    ro: [[1, [[0]]]],
    root: [],
    ru: [],
    sc: [[4, [[103]]]],
    scn: [[4, [[103]]]],
    sd: [],
    sh: [],
    si: [],
    sk: [],
    sl: [],
    sq: [
        [1, [[0]]],
        [4, [[115, 116]]]
    ],
    sr: [],
    sv: [[1, [[117, 118]]]],
    sw: [],
    ta: [],
    te: [],
    th: [],
    tk: [[3, [[119], [120]]]],
    tl: [[1, [[0]]]],
    tr: [],
    uk: [[3, [[99, 100]]]],
    ur: [],
    uz: [],
    vi: [[1, [[0]]]],
    yue: [],
    zh: [],
    zu: []
};
export var expressions = [
    ['n', 0, 1, [1]],
    ['n', 0, 1, [[0, 1]]],
    ['i', 0, 1, [0]],
    ['n', 0, 1, [0]],
    ['n', 0, 1, [2]],
    ['n', 100, 1, [[3, 10]]],
    ['n', 100, 1, [[11, 99]]],
    ['i', 0, 1, [1]],
    ['v', 0, 1, [0]],
    ['n', 10, 1, [1]],
    ['n', 100, 0, [11]],
    ['n', 10, 1, [[2, 4]]],
    ['n', 100, 0, [[12, 14]]],
    ['n', 10, 1, [0]],
    ['n', 10, 1, [[5, 9]]],
    ['n', 100, 1, [[11, 14]]],
    ['n', 100, 0, [11, 71, 91]],
    ['n', 10, 1, [2]],
    ['n', 100, 0, [12, 72, 92]],
    ['n', 10, 1, [[3, 4], 9]],
    [
        'n',
        100,
        0,
        [
            [10, 19],
            [70, 79],
            [90, 99]
        ]
    ],
    ['n', 0, 0, [0]],
    ['n', 1000000, 1, [0]],
    ['i', 10, 1, [1]],
    ['i', 100, 0, [11]],
    ['f', 10, 1, [1]],
    ['f', 100, 0, [11]],
    ['i', 10, 1, [[2, 4]]],
    ['i', 100, 0, [[12, 14]]],
    ['f', 10, 1, [[2, 4]]],
    ['f', 100, 0, [[12, 14]]],
    ['i', 0, 1, [1, 2, 3]],
    ['i', 10, 0, [4, 6, 9]],
    ['v', 0, 0, [0]],
    ['f', 10, 0, [4, 6, 9]],
    ['i', 0, 1, [[2, 4]]],
    ['n', 0, 1, [3]],
    ['n', 0, 1, [6]],
    ['t', 0, 0, [0]],
    ['i', 0, 1, [0, 1]],
    ['i', 100, 1, [1]],
    ['f', 100, 1, [1]],
    ['i', 100, 1, [2]],
    ['f', 100, 1, [2]],
    ['i', 100, 1, [[3, 4]]],
    ['f', 100, 1, [[3, 4]]],
    ['n', 0, 1, [[3, 6]]],
    ['n', 0, 1, [[7, 10]]],
    ['n', 0, 1, [1, 11]],
    ['n', 0, 1, [2, 12]],
    [
        'n',
        0,
        1,
        [
            [3, 10],
            [13, 19]
        ]
    ],
    ['i', 10, 1, [2]],
    ['i', 100, 1, [0, 20, 40, 60, 80]],
    ['i', 0, 1, [2]],
    ['n', 0, 0, [[0, 10]]],
    ['t', 0, 1, [0]],
    ['n', 100, 1, [2, 22, 42, 62, 82]],
    ['n', 1000, 1, [0]],
    ['n', 100000, 1, [[1000, 20000], 40000, 60000, 80000]],
    ['n', 1000000, 1, [100000]],
    ['n', 100, 1, [3, 23, 43, 63, 83]],
    ['n', 0, 0, [1]],
    ['n', 100, 1, [1, 21, 41, 61, 81]],
    ['n', 100, 0, [[11, 19]]],
    ['n', 10, 1, [[2, 9]]],
    ['f', 0, 0, [0]],
    ['n', 100, 1, [[11, 19]]],
    ['v', 0, 1, [2]],
    ['f', 100, 1, [[11, 19]]],
    ['v', 0, 0, [2]],
    ['n', 100, 1, [[2, 19]]],
    ['n', 100, 1, [[2, 10]]],
    ['i', 0, 0, [1]],
    ['i', 10, 1, [[0, 1]]],
    ['i', 10, 1, [[5, 9]]],
    ['i', 100, 1, [[12, 14]]],
    ['i', 0, 1, [[0, 1]]],
    ['i', 10, 1, [0]],
    ['i', 100, 1, [[11, 14]]],
    ['n', 0, 1, [[2, 10]]],
    ['n', 0, 1, [0, 1]],
    ['f', 0, 1, [1]],
    ['n', 0, 1, [[11, 99]]],
    ['n', 0, 1, [1, 5, 7, 8, 9, 10]],
    ['n', 0, 1, [2, 3]],
    ['n', 0, 1, [4]],
    ['i', 10, 1, [1, 2, 5, 7, 8]],
    ['i', 100, 1, [20, 50, 70, 80]],
    ['i', 10, 1, [3, 4]],
    ['i', 1000, 1, [100, 200, 300, 400, 500, 600, 700, 800, 900]],
    ['i', 10, 1, [6]],
    ['i', 100, 1, [40, 60, 90]],
    ['n', 10, 1, [2, 3]],
    ['n', 100, 0, [12, 13]],
    ['n', 0, 1, [1, 3]],
    ['n', 0, 1, [0, 7, 8, 9]],
    ['n', 0, 1, [3, 4]],
    ['n', 0, 1, [5, 6]],
    ['n', 100, 0, [12]],
    ['n', 10, 1, [3]],
    ['n', 100, 0, [13]],
    ['n', 0, 1, [3, 13]],
    ['n', 0, 1, [1, 5]],
    ['n', 0, 1, [11, 8, 80, 800]],
    ['i', 100, 1, [[2, 20], 40, 60, 80]],
    ['n', 10, 1, [6]],
    ['n', 10, 1, [9]],
    ['n', 0, 1, [[1, 4]]],
    [
        'n',
        100,
        1,
        [
            [1, 4],
            [21, 24],
            [41, 44],
            [61, 64],
            [81, 84]
        ]
    ],
    ['n', 0, 1, [5]],
    ['n', 100, 1, [5]],
    ['i', 100, 0, [12]],
    ['i', 10, 1, [7, 8]],
    ['i', 100, 0, [17, 18]],
    ['n', 0, 1, [1, 5, [7, 9]]],
    ['n', 10, 1, [4]],
    ['n', 100, 0, [14]],
    ['n', 10, 1, [1, 2]],
    ['n', 100, 0, [11, 12]],
    ['n', 10, 1, [6, 9]],
    ['n', 0, 1, [10]]
];
//# sourceMappingURL=autogen.rules.js.map